module.exports = __webpack_public_path__ + "app-static/img/14.0ec85e14.png";